if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
    // this.showActiveMedia();

      /**/
      this.openedBy = opener;

      console.log(opener);
      var mainCarouselEl = document.querySelector('.product-media-modal__content .main-img-wrap-inner');
      var slideCounter = document.querySelector('.product-media-modal__content .slide-counter');

      var flkty = new Flickity(mainCarouselEl, {
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        pageDots: false,
        imagesLoaded: true
      });

      const mediaId = opener?.getAttribute('data-media-id');
       if (mediaId) {
            const slides = mainCarouselEl.querySelectorAll('[data-media-id]');
            slides.forEach((slide, index) => {
              if (slide.getAttribute('data-media-id') === mediaId) {
                flkty.select(index);
              }
            });
        }

      function updateSlideCounter(index) {
        slideCounter.innerHTML = '<span>' + (index + 1) + '</span> / ' + flkty.slides.length;
      }
      updateSlideCounter(flkty.selectedIndex);

       flkty.on('change', function (index) {
          updateSlideCounter(index);

          // Pause and reset videos
          const videos = mainCarouselEl.querySelectorAll('video');
          videos.forEach(video => {
            video.pause();
            video.currentTime = 0;
          });

         const currentSlide = flkty.selectedElement;
          const deferredMedia = currentSlide?.querySelector('deferred-media');
    
          if (deferredMedia) deferredMedia.loadContent(false);
         
         
       });

       const thumbs = document.querySelectorAll('.product-media-modal__content .thumbnail-slider .media-wrap-j');
        thumbs.forEach(thumb => {
          thumb.addEventListener('click', function () {
            // const index = parseInt(this.getAttribute('data-index'), 10);
            // flkty.select(index);
            const slides = Array.from(mainCarouselEl.querySelectorAll('[data-media-id]'));
            const mediaId = this.getAttribute('data-media-id');

            const index = slides.findIndex(slide => {
              return slide.getAttribute('data-media-id') === mediaId;
            });

            if (index !== -1) {
              flkty.select(index);
            }
          });
        });
      
      
      /**/
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('is-active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('is-active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
